import React from "react";
import Base from "../core/Base";
import EnquiryModal from "../components/EnquiryModal";

const Home = () => {
  return (
    <Base>
      <div className="main-banner">
        <div className="container">
          <div className="main-banner-content">
            <div className="home-slides">
              <div className="hero-content slider-heading">
                <div className="des_data">
                  <h1>
                    Welcome <p className="to">To</p> <span>SarkariZone</span>
                  </h1>
                  <p className="text-white text-contand">
                    Welcome to the SarkariZone (Study Point & Library).
                    SarkariZone is one of the best
                    <br />
                    libraries in Agra. Here students can register online through
                    website.
                  </p>
                </div>
              </div>
            </div>
            <div className="watch-video">
              <a
                href="https://www.youtube.com/channel/UCKpimXxJeSGeuuVfoCtL2aQ/videos"
                className="popup-video"
                target="_blank"
              >
                <i className="icofont-ui-play"></i>
              </a>
              <h4>
                <button
                  type="button"
                  className="btn text-center btn-primary"
                  data-toggle="modal"
                  data-target="#exampleModal"
                >
                  Enquiy Now
                </button>
              </h4>
            </div>
          </div>
        </div>
        <div className="animation-shape">
          <div className="shape1">
            <img
              src={require("../assets/img/shape1.png")}
              alt="shape"
              className="shape1_img"
            />
          </div>
          <div className="shape2">
            <img src={require("../assets/img/shape2.png")} alt="shape" />
          </div>
        </div>
      </div>
      <div className="container mt-5 pt-5  ptb-100">
        <div className="row">
          <div className="col-md-6">
            <div className="new_contant">
              <div className="about-text">
                <h3>
                  Welcome To <span>SarkariZone</span>
                </h3>
                <p>
                  {" "}
                  SarkariZone (Study Point & Library) provides all necessary
                  requirements which students wants. We provide best facilities
                  and services to our students. SarkariZone is a great platform
                  for study point in Agra. Libraries are critical and have
                  distinctive utilizations for various people.Libraries develop
                  perusing propensities and advance advancement of learning. The
                  library is an ideal place to enjoy the delight of perusing and
                  for exploring.
                </p>
                <p>
                  {" "}
                  Library is a storage facility of books. It likewise gives
                  different wellsprings of data for perusing in its premises.
                  One can gain admittance to different classifications of books
                  and different assets in the library. It avoids the need to
                  purchase costly books and assets.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <img
              src="https://trello-attachments.s3.amazonaws.com/5f8186eddebc0f7224a214d6/550x400/b17a4d159ee491b8b5472e592bf47365/about_us_image.jpg"
              className="img-fluid"
              alt="Sarkarizone-library-study-point"
            />
          </div>
        </div>
      </div>
      <div className="section-title">
        <h3>Our Library</h3>
      </div>
      <section className="why-choose-us">
        <div className="container-fluid">
          <div className="row ptb-100" style={{ textAlign: "center" }}>
            <div className="col-md-6 mt-4">
              <iframe
                width="100%"
                height="300"
                src="https://lh3.googleusercontent.com/9cB5sXeglKgNnqFJzxTzu-4I17nqniLdq7MwEGLiC9oqujpmGddu2aCv188vndTSbWBLld28rQ=m18?cpn=GGXHDv79BqY9Dm9z"
                frameBorder="0"
              ></iframe>
            </div>
            <div className="col-md-6 mt-4">
              <iframe
                width="100%"
                height="300"
                src="https://lh3.googleusercontent.com/RLxn6rr1ChJf3m7IZtq8ZlGWyey7UvUhVit3GFyJs8eAK4KX6xm39YXGrQJ2PFXiY4rMOxOIBw=m18?cpn=OF9OS0AtxbutBLdZ"
                frameBorder="0"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
      <section className="featured-courses ptb-100">
        <div className="container">
          <div className="section-title">
            <h3>EXTRA FACILITIES</h3>
          </div>
          <div className="row ">
            <div className="col-lg-3 col-md-6">
              <div className="single-courses js-tilt">
                <div className="icon bg-1">
                  <i className="icofont-papers"></i>
                </div>
                <h3>ONLINE REGISTRATION</h3>
                <p>
                  You can register online on our website(link). Through our
                  website, You can register yourself online. Online registration
                  saves your time by taking tons of information.{" "}
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="single-courses js-tilt">
                <div className="icon bg-2">
                  <i className="icofont-chair"></i>
                </div>
                <h3>
                  LIVE
                  <br />
                  SEATS BOOKING
                </h3>
                <p>
                  You can book your seat online. Here you can check your seat
                  online that which seat is assigned for you and which seats are
                  available or not.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="single-courses js-tilt">
                <div className="icon bg-3">
                  <i className="icofont-rupee"></i>
                </div>
                <h3>ONLINE FEES SUBMITIONS</h3>
                <p>
                  You can submit your fees online. No need to deposit any type
                  of cash. There are too many ways of payment, you can choose
                  any method according to you.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="single-courses js-tilt">
                <div className="icon bg-4">
                  <i className="icofont-ui-video-message"></i>
                </div>
                <h3>
                  FEES
                  <br /> DEPOSITE SMS
                </h3>
                <p>
                  Whenever you deposit your fee then you will receive an SMS
                  about fee deposit. This is like proof too for the future that
                  you have submitted your fee on a particular date.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="why-choose-us">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6 col-md-12 ">
              <div className="image"></div>
            </div>

            <div className="col-lg-6 col-md-12">
              <div className="why-choose ptb-100 ">
                <h3>Why Choose Us</h3>
                <div className="row">
                  <div className="col-md-6 col-xs-12 mb-0">
                    <div className="single-choose">
                      <div className="icon">
                        <i className="icofont-library"></i>
                      </div>

                      <div className="content">
                        <h4>Systematic Library</h4>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-xs-12 mt-0">
                    <div className="single-choose">
                      <div className="icon">
                        <i className="icofont-safety"></i>
                      </div>

                      <div className="content">
                        <h4>Safety & Hygiene</h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row choose-us-row mt-5">
                  <div className="col-md-6 col-xs-12">
                    <div className="single-choose">
                      <div className="icon">
                        <i className="icofont-ui-mute"></i>
                      </div>

                      <div className="content">
                        <h4>Peaceful Environment</h4>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-xs-12">
                    <div className="single-choose">
                      <div className="icon">
                        <i className="icofont-cc-camera"></i>
                      </div>

                      <div className="content">
                        <h4>Fully CCTV Security</h4>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row choose-us-row mt-5">
                  <div className="col-md-6">
                    <div className="single-choose">
                      <div className="icon">
                        <i className="icofont-wifi-router"></i>
                      </div>

                      <div className="content">
                        <h4 className="new_main">
                          Fast Wifi Campus Upto 500MBPS
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-xs-12">
                    <div className="single-choose newclass">
                      <div className="icon">
                        <i className="icofont-eye-alt"></i>
                      </div>

                      <div className="content">
                        <h4 className="new_main">
                          Eyes Protecting Environment
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="fun-facts-area ptb-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-3">
              <div className="fun-fact">
                <div className="icon bg-1">
                  <img src={require("../assets/img/icon1.png")} alt="icon" />
                </div>
                <h3>
                  <span className="count">800</span>+
                </h3>
                <h5>Students</h5>
              </div>
            </div>
            <div className="col-lg-3 col-md-3">
              <div className="fun-fact">
                <div className="icon bg-2">
                  <img src={require("../assets/img/icon2.png")} alt="icon" />
                </div>
                <h3>
                  <span className="count">110</span>+
                </h3>
                <h5>Seats</h5>
              </div>
            </div>
            <div className="col-lg-3 col-md-3">
              <div className="fun-fact">
                <div className="icon bg-3">
                  <img src={require("../assets/img/icon3.png")} alt="icon" />
                </div>
                <h3>
                  <span className="count">500</span>+
                </h3>
                <h5>Books</h5>
              </div>
            </div>
            <div className="col-lg-3 col-md-3">
              <div className="fun-fact">
                <div className="icon bg-4">
                  <img src={require("../assets/img/icon4.png")} alt="icon" />
                </div>
                <h3>
                  <span className="count">97</span>+
                </h3>
                <h5>Certified Students</h5>
              </div>
            </div>
          </div>
        </div>
      </section>
      <EnquiryModal />
    </Base>
  );
};

export default Home;
